var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 20,
    viewBox: "0 0 33 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 19621"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 119",
    x: 0.5,
    y: 0.5,
    width: 31.8571,
    height: 19,
    rx: 9.5,
    stroke: "#0167B1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 32",
    cx: 22.8574,
    cy: 9.99993,
    r: 5.71429,
    fill: "#0167B1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIcon);
export default __webpack_public_path__ + "static/media/CheckedIcon.1dec16738d0fb6e118b64545303e5050.svg";
export { ForwardRef as ReactComponent };